import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en';

// Only english for now
// Extend if neccessary, and use language-detection from url?

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en
    },
    fallbackLng: 'en',

    defaultNS: 'common', // Namespaces are separated with : in t() function
    fallbackNS: 'common',

    debug: process.env.NODE_ENV === 'development',

    keySeparator: '.',

    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },

    react: {
      wait: false
    }
  });

export default i18n;
